import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWakatimeComponent } from './simple-icons-wakatime.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWakatimeComponent ],
    exports:      [ SimpleIconsWakatimeComponent ],
    bootstrap:    []
})
export class SimpleIconsWakatimeModule {}
